// extracted by mini-css-extract-plugin
module.exports = {"title":"_1VFbb4","section":"_oint5","sectionTitle":"_1hlBfm","description":"uB1mLZ","descriptionWrapper":"_3T1Q4v","brands":"DAAujH"};